import React from 'react';
import styled from 'styled-components';
import { Listing } from 'api/ListingController/getListing';
import { RecipientType } from '../OfferMessageSentPage/types';
import { ListingAgentType } from './types';
import AgentInfo from './AgentInfo';

interface AgentListProps {
  agentsRecipient: RecipientType[];
  listingAgentsRecipient: ListingAgentType[];
  agentsRemoved: RecipientType[];
  listingAgentsRemoved: ListingAgentType[];
  agentsUnsubscribed: RecipientType[];
  fetchAgents: (
    listingId_: string,
    sentTo_: string,
    listing_: Listing,
    listingAgentsRemoved_: ListingAgentType[],
    agentsRemoved_: RecipientType[],
  ) => Promise<void>;
  sentTo: string;
  listingId: string;
  listing: Listing;
  deleteListingAgent: (agentEmail: string) => void;
  restoreListingAgent: (agentEmail: string) => void;
  deleteAgent: (agentEmail: string) => void;
  restoreAgent: (agentEmail: string) => void;
  agentsListTab: string;
  setAgentsListTab: React.Dispatch<React.SetStateAction<string>>;
}

const AgentsList = ({
  agentsRecipient,
  listingAgentsRecipient,
  agentsRemoved,
  listingAgentsRemoved,
  agentsUnsubscribed,
  fetchAgents,
  sentTo,
  listingId,
  listing,
  deleteListingAgent,
  restoreListingAgent,
  deleteAgent,
  restoreAgent,
  agentsListTab,
  setAgentsListTab,
}: AgentListProps) => (
    <div className="col-md-4">
      <div className="row">
        <div className="col-md-10">
          <ul className="nav nav-tabs">
            <li
              className={
                agentsListTab === 'recipient'
                  ? 'active offer-message-navtab-active'
                  : ''
              }
            >
              <a
                onClick={() => {
                  setAgentsListTab('recipient');
                }}
                data-cy="agents-list-tab-recipient"
              >
                {`Recipients (${
                  agentsRecipient.length + listingAgentsRecipient.length
                })`}
              </a>
            </li>
            <li
              className={
                agentsListTab === 'removed'
                  ? 'active offer-message-navtab-active'
                  : ''
              }
            >
              <a
                onClick={() => {
                  setAgentsListTab('removed');
                }}
                data-cy="agents-list-tab-removed"
              >{`Removed (${
                agentsRemoved.length + listingAgentsRemoved.length
              })`}</a>
            </li>
            <li
              className={
                agentsListTab === 'unsubscribed'
                  ? 'active offer-message-navtab-active'
                  : ''
              }
            >
              <a
                onClick={() => {
                  setAgentsListTab('unsubscribed');
                }}
                data-cy="agents-list-tab-unsubscribed"
              >{`Unsubscribed (${agentsUnsubscribed.length})`}</a>
            </li>
          </ul>
        </div>
        <div className="col-md-2">
          <button
            className="pull-right btn btn-primary margin-right"
            onClick={() => {
              fetchAgents(
                listingId,
                sentTo,
                listing,
                listingAgentsRemoved,
                agentsRemoved,
              );
            }}
            data-cy="reload-agents"
          >
            Reload
          </button>
        </div>
      </div>
      {/* <!-- Recipient --> */}
      {agentsListTab === 'recipient' && (
        <div className="row">
          <div className="col-md-12">
            <StyledText>
              To ensure all recipients are included, please reload the list of
              recipients before sending.
            </StyledText>
            {agentsRecipient.length === 0 &&
              listingAgentsRecipient.length === 0 && <h5>No agents found.</h5>}
            <StyledAgentsInfoContainer>
              {listingAgentsRecipient?.map(agent => (
                <AgentInfo
                  key={agent.email}
                  agent={agent}
                  handleClick={deleteListingAgent}
                  buttonText={'Remove'}
                />
              ))}

              {agentsRecipient?.map(agent => (
                <AgentInfo
                  key={agent.email}
                  agent={agent}
                  handleClick={deleteAgent}
                  buttonText={'Remove'}
                />
              ))}
            </StyledAgentsInfoContainer>
          </div>
        </div>
      )}

      {/* <!-- Removed --> */}
      {agentsListTab === 'removed' && (
        <div className="row">
          <div className="col-md-12">
            {agentsRemoved.length === 0 &&
              listingAgentsRemoved.length === 0 && <h5>No Removed Agents.</h5>}
            <StyledAgentsInfoContainer>
              {listingAgentsRemoved?.map(agent => (
                <AgentInfo
                  key={agent.email}
                  agent={agent}
                  handleClick={restoreListingAgent}
                  buttonText={'Restore'}
                />
              ))}

              {agentsRemoved?.map(agent => (
                  <AgentInfo
                    key={agent.email}
                    agent={agent}
                    handleClick={restoreAgent}
                    buttonText={'Restore'}
                  />
                ))}
            </StyledAgentsInfoContainer>
          </div>
        </div>
      )}

      {/* <!-- Unsubscribed --> */}
      {agentsListTab === 'unsubscribed' && (
        <div className="row">
          <div className="col-md-12">
            {agentsUnsubscribed.length === 0 && (
              <h5>No Unsubscribed Agents.</h5>
            )}
            <StyledAgentsInfoContainer>
              {agentsUnsubscribed?.map(agent => (
                <AgentInfo key={agent.email} agent={agent} />
              ))}
            </StyledAgentsInfoContainer>
          </div>
        </div>
      )}
    </div>
  );

const MemoizedAgentsList = React.memo(AgentsList);

export default MemoizedAgentsList;

const StyledText = styled.p`
  padding-top: 16px;
`;

const StyledAgentsInfoContainer = styled.div`
  overflow-y: scroll;
  height: 425px;
`;
